var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"route-view route_view__base"},[_c('router-view',{attrs:{"name":"header"}}),_c('router-view',{attrs:{"name":"content"}}),_c('router-view',{attrs:{"name":"navigation"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }